export default "__VITE_ASSET__C6PSTNj$__"